export interface CategoryLink {
  nameKey: string;
  url: string;
  icon: string;
  imageUrl: string;
}

export const categoryLinks: CategoryLink[] = [
  { nameKey: 'shoes', url: 'https://kaspreadsheet.com/category-911-Shoes.html', icon: 'ri-footprint-line', imageUrl: 'https://readdy.ai/api/search-image?query=fashion%20sneakers%20shoes%20product%20photography%20white%20background%20clean%20minimal%20studio%20shot&width=400&height=400&seq=cat-shoes&orientation=squarish' },
  { nameKey: 'hoodiesSweaters', url: 'https://kaspreadsheet.com/search-912/name/Shoes.html', icon: 'ri-t-shirt-line', imageUrl: 'https://readdy.ai/api/search-image?query=cozy%20hoodies%20sweaters%20fashion%20product%20flat%20lay%20neutral%20background%20warm%20tones&width=400&height=400&seq=cat-hoodies&orientation=squarish' },
  { nameKey: 'tshirts', url: 'https://kaspreadsheet.com/search-913/name/Shoes.html', icon: 'ri-t-shirt-2-line', imageUrl: 'https://readdy.ai/api/search-image?query=t-shirts%20fashion%20product%20photography%20clean%20white%20background%20minimal%20style&width=400&height=400&seq=cat-tshirts&orientation=squarish' },
  { nameKey: 'jackets', url: 'https://kaspreadsheet.com/search-914/name/Shoes.html', icon: 'ri-windy-line', imageUrl: 'https://readdy.ai/api/search-image?query=fashion%20jackets%20outerwear%20product%20photography%20clean%20studio%20background&width=400&height=400&seq=cat-jackets&orientation=squarish' },
  { nameKey: 'pantsShorts', url: 'https://kaspreadsheet.com/search-915/name/Shoes.html', icon: 'ri-scissors-line', imageUrl: 'https://readdy.ai/api/search-image?query=fashion%20pants%20shorts%20product%20flat%20lay%20neutral%20warm%20background&width=400&height=400&seq=cat-pants&orientation=squarish' },
  { nameKey: 'headwear', url: 'https://kaspreadsheet.com/search-916/name/Shoes.html', icon: 'ri-user-line', imageUrl: 'https://readdy.ai/api/search-image?query=caps%20hats%20headwear%20fashion%20accessories%20product%20photography%20clean%20background&width=400&height=400&seq=cat-headwear&orientation=squarish' },
  { nameKey: 'sets', url: 'https://kaspreadsheet.com/search-917/name/Shoes.html', icon: 'ri-stack-line', imageUrl: 'https://readdy.ai/api/search-image?query=fashion%20matching%20sets%20outfit%20product%20photography%20clean%20minimal%20background&width=400&height=400&seq=cat-sets&orientation=squarish' },
  { nameKey: 'underwear', url: 'https://kaspreadsheet.com/search-918/name/Shoes.html', icon: 'ri-shirt-line', imageUrl: 'https://readdy.ai/api/search-image?query=underwear%20underpants%20fashion%20product%20flat%20lay%20minimal%20clean%20background&width=400&height=400&seq=cat-underwear&orientation=squarish' },
  { nameKey: 'jersey', url: 'https://kaspreadsheet.com/search-919/name/Shoes.html', icon: 'ri-shirt-fill', imageUrl: 'https://readdy.ai/api/search-image?query=sports%20jerseys%20football%20basketball%20product%20photography%20clean%20white%20background&width=400&height=400&seq=cat-jersey&orientation=squarish' },
  { nameKey: 'accessories', url: 'https://kaspreadsheet.com/search-920/name/Shoes.html', icon: 'ri-keyboard-box-line', imageUrl: 'https://readdy.ai/api/search-image?query=fashion%20accessories%20jewelry%20watches%20product%20photography%20clean%20minimal%20background&width=400&height=400&seq=cat-accessories&orientation=squarish' },
  { nameKey: 'bags', url: 'https://kaspreadsheet.com/search-921/name/Shoes.html', icon: 'ri-shopping-bag-line', imageUrl: 'https://readdy.ai/api/search-image?query=fashion%20bags%20handbags%20product%20photography%20clean%20studio%20background%20neutral%20tones&width=400&height=400&seq=cat-bags&orientation=squarish' },
  { nameKey: 'belts', url: 'https://kaspreadsheet.com/search-922/name/Shoes.html', icon: 'ri-links-line', imageUrl: 'https://readdy.ai/api/search-image?query=fashion%20belts%20accessories%20product%20photography%20clean%20minimal%20background&width=400&height=400&seq=cat-belts&orientation=squarish' },
  { nameKey: 'perfumes', url: 'https://kaspreadsheet.com/search-923/name/Shoes.html', icon: 'ri-drop-line', imageUrl: 'https://readdy.ai/api/search-image?query=perfume%20bottles%20luxury%20product%20photography%20clean%20minimal%20elegant%20background&width=400&height=400&seq=cat-perfumes&orientation=squarish' },
  { nameKey: 'otherStuff', url: 'https://kaspreadsheet.com/search-924/name/Shoes.html', icon: 'ri-more-line', imageUrl: 'https://readdy.ai/api/search-image?query=various%20lifestyle%20products%20flat%20lay%20clean%20minimal%20warm%20neutral%20background&width=400&height=400&seq=cat-other&orientation=squarish' },
];

export interface ArticleCard {
  slug: string;
  titleKey: string;
  descKey: string;
  date: string;
  readTime: number;
  category: string;
  imageUrl: string;
}

export const articleCards: ArticleCard[] = [
  {
    slug: 'allchinabuy-spreadsheet-guide',
    titleKey: 'allchinabuySpreadsheetGuide',
    descKey: 'allchinabuySpreadsheetGuideDesc',
    date: '2026-08-25',
    readTime: 8,
    category: 'spreadsheet',
    imageUrl: 'https://readdy.ai/api/search-image?query=organized%20spreadsheet%20data%20grid%20digital%20clean%20modern%20minimal%20warm%20tones%20aesthetic&width=400&height=300&seq=article-spreadsheet&orientation=landscape',
  },
  {
    slug: 'allchinabuy-review-2026',
    titleKey: 'allchinabuyReview2026',
    descKey: 'allchinabuyReview2026Desc',
    date: '2026-08-20',
    readTime: 6,
    category: 'review',
    imageUrl: 'https://readdy.ai/api/search-image?query=review%20rating%20stars%20quality%20check%20ecommerce%20modern%20minimal%20warm%20background&width=400&height=300&seq=article-review&orientation=landscape',
  },
  {
    slug: 'allchinabuy-shipping-cost',
    titleKey: 'allchinabuyShippingCost',
    descKey: 'allchinabuyShippingCostDesc',
    date: '2026-08-18',
    readTime: 7,
    category: 'shipping',
    imageUrl: 'https://readdy.ai/api/search-image?query=shipping%20packages%20delivery%20boxes%20global%20logistics%20modern%20minimal%20clean%20background&width=400&height=300&seq=article-shipping&orientation=landscape',
  },
  {
    slug: 'allchinabuy-coupon',
    titleKey: 'allchinabuyCoupon',
    descKey: 'allchinabuyCouponDesc',
    date: '2026-08-15',
    readTime: 5,
    category: 'coupon',
    imageUrl: 'https://readdy.ai/api/search-image?query=discount%20coupon%20voucher%20sale%20tags%20modern%20minimal%20clean%20warm%20tones&width=400&height=300&seq=article-coupon&orientation=landscape',
  },
  {
    slug: 'allchinabuy-warehouse-guide',
    titleKey: 'allchinabuyWarehouseGuide',
    descKey: 'allchinabuyWarehouseGuideDesc',
    date: '2026-08-12',
    readTime: 6,
    category: 'warehouse',
    imageUrl: 'https://readdy.ai/api/search-image?query=warehouse%20storage%20facility%20organized%20shelves%20modern%20clean%20minimal%20industrial&width=400&height=300&seq=article-warehouse&orientation=landscape',
  },
  {
    slug: 'is-allchinabuy-legit',
    titleKey: 'isAllchinabuyLegit',
    descKey: 'isAllchinabuyLegitDesc',
    date: '2026-08-10',
    readTime: 5,
    category: 'legit',
    imageUrl: 'https://readdy.ai/api/search-image?query=security%20shield%20trust%20badge%20safety%20verification%20modern%20minimal%20clean%20background&width=400&height=300&seq=article-legit&orientation=landscape',
  },
  {
    slug: 'allchinabuy-vs-superbuy',
    titleKey: 'allchinabuyVsSuperbuy',
    descKey: 'allchinabuyVsSuperbuyDesc',
    date: '2026-08-08',
    readTime: 9,
    category: 'comparison',
    imageUrl: 'https://readdy.ai/api/search-image?query=comparison%20chart%20balance%20scale%20vs%20modern%20minimal%20clean%20warm%20tones&width=400&height=300&seq=article-vs&orientation=landscape',
  },
  {
    slug: 'allchinabuy-beginner-guide',
    titleKey: 'allchinabuyBeginnerGuide',
    descKey: 'allchinabuyBeginnerGuideDesc',
    date: '2026-08-05',
    readTime: 10,
    category: 'guide',
    imageUrl: 'https://readdy.ai/api/search-image?query=beginner%20guide%20tutorial%20book%20open%20learning%20modern%20minimal%20clean%20warm%20background&width=400&height=300&seq=article-beginner&orientation=landscape',
  },
];